/* eslint-disable max-len */
import React, { useMemo, useRef } from 'react';

// Redux
import { useSelector } from 'react-redux';

// Draggable Scroll
import { useDraggable } from 'react-use-draggable-scroll';

// Material
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

// Types
import { ApplicationState } from 'store';
import { CompanyReportInterface } from 'store/ducks/company/types';

// Components
import { TabPanel } from 'components/TabPanel';

// Helpers
import { currencyFormat } from 'helpers/currencyFormat';

// Styles
import useStyles from './detailedCompanyAcquisitions.styles';

interface DetailedCompanyAcquisitionsInterface {
  companyList?: CompanyReportInterface[];
}

type Props = DetailedCompanyAcquisitionsInterface;

const DetailedCompanyAcquisitions: React.FC<Props> = ({ companyList }) => {
  const classes = useStyles();
  const parentRef: any = useRef();
  const { events } = useDraggable(parentRef);

  const companyReportList = useSelector((state: ApplicationState) =>
    companyList && companyList.length
      ? companyList
      : state.companyReport.companyReportList,
  );
  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const transportOperatorsList = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList,
  );
  const renderValue = useMemo(
    () => (value: string) => currencyFormat({ value: parseFloat(value) || 0 }),
    [],
  );

  return (
    <TabPanel index={0} value={0}>
      <TableContainer
        className={classes.tableContainer}
        {...events}
        ref={parentRef}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell variant='head' align='left'>
                Empresa
              </TableCell>
              <TableCell variant='head' align='left'>
                JAN
              </TableCell>
              <TableCell variant='head' align='left'>
                FEV
              </TableCell>
              <TableCell variant='head' align='left'>
                MAR
              </TableCell>
              <TableCell variant='head' align='left'>
                ABR
              </TableCell>
              <TableCell variant='head' align='left'>
                MAI
              </TableCell>
              <TableCell variant='head' align='left'>
                JUN
              </TableCell>
              <TableCell variant='head' align='left'>
                JUL
              </TableCell>
              <TableCell variant='head' align='left'>
                AGO
              </TableCell>
              <TableCell variant='head' align='left'>
                SET
              </TableCell>
              <TableCell variant='head' align='left'>
                OUT
              </TableCell>
              <TableCell variant='head' align='left'>
                NOV
              </TableCell>
              <TableCell variant='head' align='left'>
                DEZ
              </TableCell>
              {transportOperatorSelected.type === 1 && (
                <TableCell variant='head' align='left'>
                  Operação
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(companyReportList) &&
              companyReportList.length > 0 &&
              companyReportList.map((company) => (
                <TableRow key={company.name}>
                  <TableCell>{company.name}</TableCell>
                  <TableCell>{renderValue(company?.months?.['1'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['2'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['3'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['4'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['5'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['6'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['7'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['8'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['9'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['10'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['11'])}</TableCell>
                  <TableCell>{renderValue(company?.months?.['12'])}</TableCell>
                  {transportOperatorSelected.type === 1 && (
                    <TableCell>
                      {transportOperatorsList.find(
                        (e) => e.id === company?.transportOperatorId,
                      )?.name || '---'}
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </TabPanel>
  );
};

export default DetailedCompanyAcquisitions;
export { DetailedCompanyAcquisitions };
